import React, { useEffect, useState } from 'react';
import './index.scss';

const ListContainer = ({ children }) => {
  return <div className="world-list">{children}</div>;
};

export default ListContainer;
